import React from 'react';
import PropTypes from 'prop-types';
import '../style.scss';

/**
 * FrontLayer :
 * - FrontLayer for HexagonCard
 */
export function FrontLayer(props) {
  return (
    <>
      <div className='hex_shape'></div>
    </>
  );
}

FrontLayer.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
};

FrontLayer.defaultProps = {
  className: '',
};
